import ShowCase from '../ShowCase';
import AboutMe from '../AboutMe';
import Occupation from '../Occupation';
import Skills from '../Skills';
import Projects from '../Projects';

export const Home = () => (
	<>
		<ShowCase />

		<AboutMe />

		<Occupation />

		<Skills />

		<Projects />
	</>
);
